/**
 * Verbos: the answer, and the whole paradigm under it.
 *
 * The shared back already has a `detail` slot for exactly this. What Verbos
 * puts in it is the conjugation with the endings highlighted, which is the
 * thing this deck exists to teach: the meaning is one card, the pattern is
 * every card.
 */
import { TranslationCardBack } from '@/components/practice/TypeTranslationCard';

import type { CardBackProps } from '../types';

import { ConjugationTable } from './ConjugationTable';
import type { VerboPayload } from './types';

export function CardBack({
  card,
  correct,
  primary_lang,
  secondary_lang,
  isLastCard,
  onNext,
}: CardBackProps<VerboPayload>) {
  return (
    <TranslationCardBack
      card={card}
      correct={correct}
      primary_lang={primary_lang}
      secondary_lang={secondary_lang}
      isLastCard={isLastCard}
      onNext={onNext}
      headword={card.de}
      detail={<ConjugationTable payload={card.payload} />}
    />
  );
}
